import { render, staticRenderFns } from "./VendorPage.vue?vue&type=template&id=fe486470&"
import script from "./VendorPage.vue?vue&type=script&lang=js&"
export * from "./VendorPage.vue?vue&type=script&lang=js&"
import style0 from "./VendorPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports